import React from 'react';

function StartupFooter() {
  return (
    <footer>
      <p className='text-yellow-200'>&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
      <p>Contact: contact@think5whys.com</p>
    </footer>
  );
}

export default StartupFooter;